import clickAndCollect from '../services/click-and-collect';
import MicroModal from 'micromodal';
import noUiSlider from 'nouislider';
let clickAndCollectModalContainer = null;
// Obiekt składujący stan wyborów w menu, aby móc dokonać jego serializacji
const menuState = {};
/** Inicjalizacja wyboru sklepu stacjonarnego w menu */
const initClickAndCollectShopSelection = () => {
    // Otwieranie modala z wyborem sklepu po kliknięciu "Zmień sklep"
    document.querySelectorAll('.cc-choose-shop').forEach((chooseShop) => {
        // Po kliknięciu w przycisk pobieramy kod HTML listy sklepów i wyświetlamy go w modalu
        chooseShop.addEventListener('click', (e) => {
            e.preventDefault();
            const endpointUrl = '/shop/getlist';
            const shopId = chooseShop.dataset.shopId;
            const formData = new FormData();
            formData.append('limit', '0');
            if (typeof shopId === 'string') {
                formData.append('shopId', shopId);
            }
            fetch(endpointUrl, {
                method: 'POST',
                cache: 'no-cache',
                body: formData,
            })
                .then((response) => {
                if (!response.ok) {
                    throw new Error('Unknown failure');
                }
                return response.text();
            })
                .then((response) => {
                if (clickAndCollectModalContainer === null) {
                    clickAndCollectModalContainer = document.createElement('div');
                    clickAndCollectModalContainer.innerHTML = `
                        <div class="modal micromodal-slide" id="modal-cc-shops" aria-hidden="true">
                            <div class="overlay" tabindex="-1" data-micromodal-close>
                                <div class="container" role="dialog" aria-modal="true">
                                    <div class="header">&nbsp;
                                        <button class="close" data-micromodal-close></button>
                                    </div>
                                    <div class="content"></div>
                                </div>
                            </div>
                        </div>
                    `;
                    document.body.append(clickAndCollectModalContainer);
                }
                const modalCCShops = clickAndCollectModalContainer.children.item(0);
                const modalCCShopsContent = modalCCShops.querySelector('.content');
                if (modalCCShopsContent) {
                    modalCCShopsContent.innerHTML = response;
                }
                modalCCShops.dataset.remote = endpointUrl;
                modalCCShops.dataset.shopId = shopId;
                MicroModal.show('modal-cc-shops', {
                    disableScroll: true,
                    onClose: (modal, activeElement, event) => {
                        // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
                        if (event !== null) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                });
                clickAndCollect.initModal(modalCCShops);
            })
                .catch((err) => {
                console.error(err);
            });
        });
    });
    // Obsługa przekierowania w momencie zmiany sklepu
    window.addEventListener('selected-cc-shop', (data) => {
        const detail = data.detail;
        const shopID = detail !== null ? detail.shop.id : null;
        const searchParams = new URLSearchParams(window.location.search);
        // Jeżeli istniał filtr na produkty dostępne w sklepie, użytkownik powinien powrócić do pierwszej strony wyników
        if (searchParams.has('is')) {
            searchParams.delete('page');
        }
        if (shopID !== null) {
            searchParams.set('shop', shopID.toFixed());
        }
        else {
            searchParams.delete('shop');
            searchParams.delete('is');
        }
        window.location.search = searchParams.toString();
    });
};
/** Pobierz aktualny wybór filtrów wynikający ze stanu DOM filtrów */
const getCurrentFeatureSelection = () => {
    const currentSelection = new Set();
    // Zbierz aktualny wybór z filtrów
    for (const feature of document.querySelectorAll('.filter-element[data-id][data-url-name]')) {
        // Parametry cechy
        const id = feature.dataset.id;
        const urlName = feature.dataset.urlName;
        if (typeof id === 'undefined' || typeof urlName === 'undefined' || id.length === 0 || urlName.length === 0) {
            continue;
        }
        // Zbierz wybrane wartości
        const selectedValues = new Set();
        for (const valueContainer of feature.querySelectorAll('.filter-element__item')) {
            const selected = valueContainer.querySelector('input[type=checkbox]')?.checked;
            if (selected !== true) {
                continue;
            }
            const anchor = valueContainer.querySelector('a.filter-element__label');
            if (anchor === null) {
                continue;
            }
            const valueID = anchor.dataset.id;
            const valueUrlName = anchor.dataset.urlName;
            if (typeof valueID === 'undefined' ||
                typeof valueUrlName === 'undefined' ||
                valueID.length === 0 ||
                valueUrlName.length === 0) {
                continue;
            }
            selectedValues.add({ id: valueID, urlName: valueUrlName });
        }
        if (selectedValues.size > 0) {
            currentSelection.add({
                id,
                urlName,
                values: selectedValues,
            });
        }
    }
    return currentSelection;
};
/**
 * Przekształć wybór cech i ich wartości w wartość parametru "f"
 *
 * Logika taka sama jak w SelectedFeatures.php::toUriString()
 */
const mapSelectedFeaturesToString = (selection) => {
    if (selection.size === 0) {
        return null;
    }
    // Teksty opisujące wybór każdej cechy osobno
    const featuresData = [];
    // Zebranie cech posortowanych wg ID
    const sortedFeatures = Array.from(selection).sort((a, b) => parseInt(a.id) - parseInt(b.id));
    for (const feature of sortedFeatures) {
        // Wykluczenie pustych cech (jeżeli pozostały w pamięci)
        if (feature.values.size === 0) {
            continue;
        }
        // Zebranie wartości posortowanych wg ID
        const values = Array.from(feature.values).sort((a, b) => parseInt(a.id) - parseInt(b.id));
        // Zbudowanie opisu cechy
        const data = [feature.id, feature.urlName];
        for (const value of values) {
            data.push(value.id, value.urlName);
        }
        featuresData.push(data.join(','));
    }
    // Zwracamy null w przypadku pustego wyboru
    if (featuresData.length === 0) {
        return null;
    }
    return featuresData.join(',,');
};
// Inicjalizacja obsługi zaznaczania filtrów poprzez klikanie w checkboksy (możliwość wyboru
// kilku filtrów przed przeładowaniem strony)
const initFeatureFilters = () => {
    // Obsługa przycisków wyboru filtra
    for (const anchor of document.querySelectorAll('a.filter-element__label')) {
        anchor.addEventListener('click', (e) => {
            // Jeżeli kliknięto w tekst (span), nie blokujemy przekierowania wynikającego z linka
            if (e.target instanceof HTMLSpanElement) {
                return;
            }
            // Kliknięto w checkbox, zmieniamy jego stan
            const checkbox = anchor.previousElementSibling;
            if (!(checkbox instanceof HTMLInputElement)) {
                console.error('Previous element is not a checkbox, cannot handle features selection');
                return;
            }
            // Blokujemy przekierowanie
            e.preventDefault();
            checkbox.checked = !checkbox.checked;
            // Zapisujemy wybór w obiekcie stanu menu filtrów, aby kliknięcie "Filtruj" zmieniło cechy
            menuState.features = getCurrentFeatureSelection();
            // Jeżeli zmieniony element to filtr "Dostępne w sklepie", zapisujemy jego stan.
            if (checkbox.id === 'filter_checkbox_shop_available') {
                menuState.onlyAvailableInStore = checkbox.checked;
            }
        });
    }
};
const getCurrentFilterBySelection = () => {
    const currentSelection = new Set();
    for (const filterByElements of document.querySelectorAll('.filter-element.filter-by .filter-element__item')) {
        const anchor = filterByElements.querySelector('a.filter-element__label');
        if (anchor === null) {
            continue;
        }
        const selected = filterByElements.querySelector('input[type=checkbox]')?.checked;
        if (typeof selected === 'undefined') {
            continue;
        }
        const urlName = anchor.dataset.urlName;
        if (typeof urlName === 'undefined' || urlName.length === 0) {
            continue;
        }
        const selectedFilterBy = { urlName: urlName, selected: selected };
        currentSelection.add(selectedFilterBy);
    }
    return currentSelection;
};
const initFilterByFilters = () => {
    const items = document.querySelectorAll('.filter-by a.filter-element__label');
    items.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            // Jeżeli kliknięto w tekst (span), nie blokujemy przekierowania wynikającego z linka
            if (e.target instanceof HTMLSpanElement) {
                return;
            }
            // Kliknięto w checkbox, zmieniamy jego stan
            const checkbox = anchor.previousElementSibling;
            if (!(checkbox instanceof HTMLInputElement)) {
                console.error('Previous element is not a checkbox, cannot handle features selection');
                return;
            }
            // Blokujemy przekierowanie
            e.preventDefault();
            menuState.filterBy = getCurrentFilterBySelection();
        });
    });
};
// Inicjalizacja przycisku "Filtruj"
const initFilterButton = () => {
    const buttons = document.querySelectorAll('.js-btn-filter');
    buttons.forEach((button) => {
        // Po wciśnięciu przycisku przetwarzamy stan menu na parametry URLa i aktualizujemy go
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const searchParams = new URLSearchParams(window.location.search);
            // Ograniczenie do produktów dostępnych w aktualnym sklepie stacjonarnym
            if (typeof menuState.onlyAvailableInStore !== 'undefined') {
                if (menuState.onlyAvailableInStore) {
                    searchParams.set('is', '1');
                }
                else {
                    searchParams.delete('is');
                }
                // Wracamy na pierwszą stronę wyników (użytkownik mógł trafić poza zakres stron po filtracji)
                searchParams.delete('page');
            }
            // Filtr cenowy
            let priceFilter = null;
            if (typeof menuState.priceRange !== 'undefined') {
                // Dotykamy parametrów URL tylko, jeżeli komponent został wyrenderowany
                // Jeżeli nie znajduje się w kodzie HTML, nie modyfikujemy wyboru
                if (menuState.priceRange.startValue !== menuState.priceRange.startRange ||
                    menuState.priceRange.endValue !== menuState.priceRange.endRange) {
                    priceFilter = `${menuState.priceRange.startValue.toFixed()},${menuState.priceRange.endValue.toFixed()}`;
                }
                if (priceFilter === null) {
                    searchParams.delete('p');
                }
                else {
                    searchParams.set('p', priceFilter);
                }
                // Wracamy na pierwszą stronę wyników (użytkownik mógł trafić poza zakres stron po filtracji)
                searchParams.delete('page');
            }
            // Filtry (cechy/tagi)
            if (typeof menuState.features !== 'undefined') {
                // Dotykamy parametrów URL tylko, jeżeli użytkownik faktycznie zmienił stan filtrów poprzez kliknięcie
                // w checkbox
                const featuresString = mapSelectedFeaturesToString(menuState.features);
                if (featuresString === null) {
                    searchParams.delete('f');
                }
                else {
                    searchParams.set('f', featuresString);
                }
                // Wracamy na pierwszą stronę wyników (użytkownik mógł trafić poza zakres stron po filtracji)
                searchParams.delete('page');
            }
            if (typeof menuState.filterBy !== 'undefined') {
                menuState.filterBy.forEach((filterBy) => {
                    if (filterBy.selected) {
                        searchParams.set(filterBy.urlName, '1');
                    }
                    else {
                        searchParams.delete(filterBy.urlName);
                    }
                });
            }
            // Nadpisanie parametrów w adresie URL
            // Spowoduje przekierowanie tylko, jeżeli faktycznie zmieniły się
            window.location.search = searchParams.toString();
        });
    });
};
/** Inicjalizacja wyświetlania i zmiany zakresu cenowego */
const initPriceRangeSlider = () => {
    const element = document.querySelector('#price-slider');
    if (element === null) {
        return;
    }
    // Elementy składujące tekst z aktualnie wybranym zakresem
    const lowerValueSpan = document.querySelector('#price-lower-value');
    const upperValueSpan = document.querySelector('#price-upper-value');
    // Dostępny zakres
    const startRange = typeof element.dataset.startRange !== 'undefined' ? parseFloat(element.dataset.startRange) : 0;
    const endRange = typeof element.dataset.endRange !== 'undefined' ? parseFloat(element.dataset.endRange) : 0;
    // Początkowy zakres wyboru
    const startValue = typeof element.dataset.startValue !== 'undefined' ? parseFloat(element.dataset.startValue) : startRange;
    const endValue = typeof element.dataset.endValue !== 'undefined' ? parseFloat(element.dataset.endValue) : endRange;
    // Ustawienie wybranego zakresu w obiekcie składującym stan menu
    menuState.priceRange = {
        startRange,
        endRange,
        startValue,
        endValue,
    };
    // Inicjalizacja slidera wyboru zakresu
    const slider = noUiSlider.create(element, {
        start: [startValue, endValue],
        step: 1,
        connect: true,
        range: {
            min: startRange,
            max: endRange,
        },
        format: {
            to: (v) => parseFloat(parseFloat(v).toFixed()),
            from: (v) => parseFloat(parseFloat(v).toFixed()), // Podwójny cast, aby uniknąć problemów z .0000001
        },
    });
    // Aktualizacja informacji tekstowej o wybranym zakresie oraz aktualizacja stanu menu po przesunięciu suwaka
    slider.on('update', (values) => {
        if (typeof values[0] === 'undefined' || typeof values[1] === 'undefined') {
            return;
        }
        // Aktualizacja stanu menu
        if (typeof menuState.priceRange !== 'undefined') {
            menuState.priceRange.startValue = values[0];
            menuState.priceRange.endValue = values[1];
        }
        // Aktualizacja informacji tekstowej
        if (lowerValueSpan) {
            lowerValueSpan.innerText = values[0].toFixed();
        }
        if (upperValueSpan) {
            upperValueSpan.innerText = values[1].toFixed();
        }
    });
};
const initToggleFilters = () => {
    const toggleFiltersButtons = document.querySelectorAll('.toggle-filters .toggle-filters__button');
    let isMobile = window.innerWidth < 800;
    const productListPage = document.querySelector('.product-list-page');
    if (!productListPage) {
        return;
    }
    window.addEventListener('resize', function () {
        isMobile = window.innerWidth < 800;
        if (isMobile) {
            return;
        }
        const body = document.querySelector('body');
        if (!body) {
            return;
        }
        body.style.overflow = '';
    }, true);
    const removeFiltersChecked = () => {
        const body = document.querySelector('body');
        const leftContainer = productListPage.querySelector('.left-column-container');
        const children = productListPage.querySelectorAll('.left-column-container *');
        if (!body || !leftContainer) {
            return;
        }
        productListPage.classList.remove('filters-checked');
        if (!isMobile) {
            leftContainer.classList.add('slide-in');
            children.forEach((child) => {
                setTimeout(() => {
                    child.classList.add('opacity-0');
                    child.classList.remove('d-none');
                    setTimeout(() => {
                        // child.style.opacity = '1';
                        child.classList.remove('opacity-0');
                        leftContainer.classList.remove('slide-in');
                    }, 100);
                }, 200);
            });
        }
        if (isMobile) {
            body.style.overflow = '';
        }
    };
    const addFiltersChecked = () => {
        const body = document.querySelector('body');
        const leftContainer = productListPage.querySelector('.left-column-container');
        const children = productListPage.querySelectorAll('.left-column-container *');
        if (!body || !leftContainer) {
            return;
        }
        productListPage.classList.add('filters-checked');
        if (!isMobile) {
            children.forEach((child) => {
                setTimeout(() => {
                    child.classList.add('d-none');
                    child.classList.add('opacity-0');
                }, 200);
            });
        }
        if (isMobile) {
            body.style.overflow = 'hidden';
        }
    };
    toggleFiltersButtons.forEach((toggleFiltersButton) => {
        toggleFiltersButton.addEventListener('click', (e) => {
            e.preventDefault();
            const isFiltersChecked = productListPage.classList.contains('filters-checked');
            isFiltersChecked ? removeFiltersChecked() : addFiltersChecked();
        });
    });
    // Zamykamy okienko z filtrami jeśli otwarto serachbar - uwaga, tylko dla mobile
    window.addEventListener('toggle-mobile-search', (event) => {
        if (!isMobile) {
            return;
        }
        if (!event.detail.visible) {
            return;
        }
        removeFiltersChecked();
    });
};
export default () => {
    // Obsługa elementu zmiany sortowania
    document.querySelectorAll('.sort-selector').forEach((select) => {
        select.addEventListener('tc-selected-option', (e) => {
            if (!(e instanceof CustomEvent)) {
                return;
            }
            if (!(e.detail instanceof Element)) {
                return;
            }
            const dataUrl = e.detail.getAttribute('data-url');
            if (dataUrl === null) {
                return;
            }
            window.location.assign(dataUrl);
        });
    });
    // Obsługa elementu zmiany ilości wyników na stronę
    document.querySelectorAll('select.perpage-selector').forEach((select) => {
        select.addEventListener('change', () => {
            const selectedOption = select.options.item(select.options.selectedIndex);
            if (selectedOption !== null && typeof selectedOption.dataset.url === 'string') {
                window.location.assign(selectedOption.dataset.url);
            }
        });
    });
    // Inicjalizacja przycisku realizującego ukrywanie/pokazywanie filtrów
    initToggleFilters();
    // Obsługa wyboru sklepu stacjonarnego w menu
    initClickAndCollectShopSelection();
    // Obsługa wyświetlania i zmiany zakresu cenowego
    initPriceRangeSlider();
    // Obsługa wybierania filtrów poprzez klikanie w checkboksy
    initFeatureFilters();
    // Obsługa przycisku "Filtruj"
    initFilterButton();
    // // Obsługa przycisków "Filtruj według" nowości oraz bestsellery
    initFilterByFilters();
};
